import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../components/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { authSelector } from "../../../redux/modules/auth/userSelector";
import { reset } from "../../../redux/modules/auth/slice";
import { login, logout } from "../../../redux/modules/auth/actions";

export default function UserLogin() {
  const [keepSignedIn, setKeepSignedIn] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const auth = useSelector(authSelector);
  const { status, message, user } = auth;

  const handleLogin = () => {
    if (!email || !password) {
      setError("Please enter email and password");
      return;
    }
  
    const userCredentials = { email, password };
    localStorage.setItem("remember_me", keepSignedIn.toString());
  
    dispatch(login(userCredentials))
      .unwrap()
      .catch((err: any) => {
        console.log("Login error:", err); 
        const msg =
          err?.response?.data?.error?.message ||
          err?.error?.message ||
          (Array.isArray(err?.message) ? err.message.join(" ") : err?.message) ||
          "Invalid email or password";
  
    
        setError(msg);
      });
  };
  

  // ✅ On successful login
  useEffect(() => {
    if (user) {
      if (!user.is_deleted) {
        // Reset auth status so PrivateRoute doesn't hold stale "success" state
        // during the route transition — prevents the login form briefly rendering
        // on top of the home page.
        dispatch(reset());
        if (!user.isTermsAccepted) {
          navigate("/terms");
        } else {
          navigate("/home");
        }
      } else {
        setError("You are not allowed to login");
        dispatch(reset());
      }
    }
  }, [user, navigate, dispatch]);

  // ✅ Keep "Remember me" synced
  useEffect(() => {
    const tokenPersist = localStorage.getItem("remember_me");
    setKeepSignedIn(tokenPersist === "true");
  }, []);

  // ✅ Clear error when user starts typing again
  useEffect(() => {
    if (error) setError("");
  }, [email, password]);

  // After a successful login the useEffect above calls navigate("/home").
  // During the brief window before the navigation completes, this component
  // is still mounted. Rendering the full form here causes it to briefly
  // overlap the new route's layout — which was the source of the UI
  // distortion. Returning only the Spinner keeps the screen clean until
  // the navigation finishes.
  if (user) return <Spinner />;

  return (
    <>
      {status === "loading" && <Spinner />}

      <div className="sign-up-wrap">
        <div className="header-container">
          <div className="row w-100">
            <div className="col-12">
              <h1 className="logo">
                Wendwise
                <sup className="tm">TM</sup>
              </h1>
            </div>
          </div>
        </div>

        <div className="form-container-wrap">
          <form
            className="form-container1"
            onSubmit={(e) => e.preventDefault()}
          >
            <h2>User Sign In</h2>

            <div className="form-group">
              {/* ✅ Display backend or validation error messages */}
              {/* ✅ Show only one error — prefer detailed one if available */}
{error ? (
  <p className="text-danger font-weight-bold">{error}</p>
) : status === "failed" && message ? (
  <p className="text-danger font-weight-bold">{message}</p>
) : null}


              <label htmlFor="useremail">Email</label>
              <input
                type="email"
                className="form-control"
                id="useremail"
                placeholder="Enter your email address"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="passwd">Password</label>
              <input
                type="password"
                className="form-control"
                id="passwd"
                placeholder="Enter password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="forgot-link d-flex align-items-center justify-content-between">
              <div className="custom-control custom-checkbox login-check">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="remember"
                  checked={keepSignedIn}
                  onChange={() => setKeepSignedIn(!keepSignedIn)}
                />
                <label htmlFor="remember" className="custom-control-label">
                  Keep me signed in
                </label>
              </div>
              {/* <Link to="/password-reset">Forgot Password?</Link> */}
            </div>

            <button
              type="submit"
              className="btn mt-5 btn-block"
              id="btn-submit"
              onClick={handleLogin}
            >
              Sign In
            </button>
          </form>
        </div>
      </div>
    </>
  );
}